import { Link } from "react-router-dom";
import { DropdownMenu, Icon, Typography } from "@/components/atoms";
import { NetworkItem } from "@/redux/slices/network/types";

interface TableActionsDropdownProps {
  item: NetworkItem;
  acceptInvitation: (id: string) => void;
  declineInvitation: (id: string) => void;
  setPendingDisconnectRelationship: (item: NetworkItem) => void;
}

export const TableActionsDropdown = ({
  item,
  setPendingDisconnectRelationship,
  acceptInvitation,
  declineInvitation,
}: TableActionsDropdownProps) => {

  return (
    <DropdownMenu button={<Icon name="options" isCustom size="lg" />} position="bottom-start" className="!flex max-w-[24px]">
      {item.status === "pending" ? (
        <>
          {item.ownsRelationship ? (
            <DropdownMenu.Item onClick={() => setPendingDisconnectRelationship(item)}>
              <Icon name="LocationDiscover" size="sm" className="mr-2.5" variant="Bold" />
              <Typography variant="paragraph">Disconnect Relationship</Typography>
            </DropdownMenu.Item>
          ) : (
            <>
              <DropdownMenu.Item onClick={() => acceptInvitation(item.id)}>
                <Icon name="TickCircle" variant="Bold" size="md" className="mr-2 text-success" />
                <Typography variant="paragraph">Accept Invitation</Typography>
              </DropdownMenu.Item>
              <DropdownMenu.Item onClick={() => declineInvitation(item.id)}>
                <Icon name="CloseCircle" variant="Bold" size="md" className="mr-2 text-danger" />
                <Typography variant="paragraph">Decline Invitation</Typography>
              </DropdownMenu.Item>
            </>
          )}
        </>
      ) : (
        <>
          <Link to={`${item.id}/history`}>
            <DropdownMenu.Item>
              <Icon name="Clock" size="sm" className="mr-2.5" />
              <Typography variant="paragraph">View History Logs</Typography>
            </DropdownMenu.Item>
          </Link>

          {item.status === "active" && (
            <Link to={`${item.id}/fleet-leaders/${item.operator.id}`}>
              <DropdownMenu.Item>
                <Icon name="UserSquare" size="sm" className="mr-2.5" />
                <Typography variant="paragraph">View Fleet Leaders</Typography>
              </DropdownMenu.Item>
            </Link>
          )}
          {item.status !== "disconnected" && item.status !== "rejected" && (
            <DropdownMenu.Item onClick={() => setPendingDisconnectRelationship(item)}>
              <Icon name="LocationDiscover" size="sm" className="mr-2.5" variant="Bold" />
              <Typography variant="paragraph">Disconnect Relationship</Typography>
            </DropdownMenu.Item>
          )}
        </>
      )}
    </DropdownMenu>
  );
};
